import React, {Component} from 'react';
import "./CustomizationPage.css";
import Layers from "../CustomizationFormFields/Layers";
import Thickness from "../CustomizationFormFields/Thickness";
import InnerLayer from "../CustomizationFormFields/InnerLayer";
import ImpedanceType from "../CustomizationFormFields/ImpedanceType";
import ImpedanceValue from "../CustomizationFormFields/ImpedanceValue";
import TraceWidth from "../CustomizationFormFields/TraceWidth";
import TraceSpace from "../CustomizationFormFields/TraceSpace";

class CustomizationForm extends Component {

    constructor() {
        super();

        this.state = {
            layerValue: false,
            impedanceType: false,
            impedanceValue: null
        }
    }

    setThicknessForSelectedLayer = (layerValue) => {
        this.setState({layerValue: layerValue})
    };
    setTraceSpaceForImpedanceType = (impedanceType) => {
        this.setState({impedanceType: impedanceType})
    };
    setImpedanceValueToPreview = (impedanceValue) => {
        this.setState({impedanceValue: impedanceValue});
        this.props.getImpedanceValueStatus(this.state.impedanceValue);
    };

    render() {
        return (

            <div className="impedance-customize-div ">
                {this.props.selectValue === "1" &&
                    <div className="row">
                        <ImpedanceValue setImpedanceValueToPreview={this.setImpedanceValueToPreview}/>
                    </div>
                }
                {this.props.selectValue === "2" &&
                    <div className="row">
                        <TraceWidth setImpedanceValueToPreview={this.setImpedanceValueToPreview}/>
                    </div>
                }
                <div className="row"><Layers setThicknessForSelectedLayer={this.setThicknessForSelectedLayer}/></div>
                <div className="row"><Thickness layerValue={this.state.layerValue}/></div>
                <div className="row"><InnerLayer/></div>
                <div className="row"><ImpedanceType setTraceSpaceForImpedanceType={this.setTraceSpaceForImpedanceType}/>
                </div>
                {this.state.impedanceType === true &&
                    <div className="row"><TraceSpace/></div>
                }

            </div>

        );
    }

}

export default CustomizationForm;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/ImpedanceCalculator/ImpedenceCustomization/CustomizationForm.js